/* Золото особой подборки (goldHTML в bot-studio.js, V149 вариант G-B): тёплый градиент текста,
   перелив светлой полосой по слову и пыль частиц. Правила и токены — studio.css (.st-gold, .st-sw, .st-dust).
   Движение — только transform и opacity; пока подпись за краем, анимации стоят (класс .paused),
   при «уменьшить движение» перелива нет, а пыль замирает — это уже делает CSS. */
import { useEffect, useRef } from 'react';

/** Точки пыли: [x %, y %, dx px, dy px, длительность с, сдвиг фазы с] — те же, что у «Материалов» «Партнёрства» */
const DUST: Array<[number, number, number, number, number, number]> = [
  [6, 72, 6, -9, 3.2, 0.4],
  [20, 20, 8, -7, 2.8, 1.9],
  [36, 86, 5, -10, 3.6, 2.7],
  [53, 12, 9, -6, 2.6, 0.9],
  [67, 80, 7, -10, 3.4, 1.5],
  [82, 26, 6, -8, 3, 2.3],
  [95, 62, 7, -9, 2.7, 0.2],
  [45, 48, 9, -11, 4, 3.1],
];

export function StudioGold({ text, sweep = true }: { text: string; sweep?: boolean }) {
  const host = useRef<HTMLSpanElement>(null);
  /* Подпись ушла за край (листается сегмент, прокручена лента) — анимации останавливаются */
  useEffect(() => {
    const element = host.current;
    if (!element || typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(entries =>
      entries.forEach(entry => entry.target.classList.toggle('paused', !entry.isIntersecting)),
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  return (
    <span className={`st-gold${sweep ? '' : ' nosw'}`} ref={host}>
      <span className="t">
        {text}
        {sweep && (
          <span className="st-sw" aria-hidden="true">
            <span>{text}</span>
          </span>
        )}
        <span className="st-dust" aria-hidden="true">
          {DUST.map(([x, y, dx, dy, duration, phase], index) => (
            <i
              key={index}
              style={
                {
                  '--x': `${x}%`,
                  '--y': `${y}%`,
                  '--dx': `${dx}px`,
                  '--dy': `${dy}px`,
                  '--d': `${duration}s`,
                  '--t': `-${phase}s`,
                } as React.CSSProperties
              }
            />
          ))}
        </span>
      </span>
    </span>
  );
}
